/*
 * @Author: Teemo Ding
 * @Date: 2021-05-26 17:49:06
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-08 10:22:22
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/collection/index.ts
 */
import { get, post } from 'src/tools/server';

const getPromotionTags = (uuid, type) => {
  return get(`/portal/salesChannelProduct/promotionTags/${uuid}/${type}`, {});
};

const postPromotionTagsSort = (body) => {
  return post(`/portal/salesChannelProduct/promotionTags/sort`, body, {});
};

const deletePromotionTags = (body) => {
  return post(`/portal/salesChannelProduct/promotionTags/delete`, body, {});
};

const getPromotionTag = (uuid, params) => {
  return get(`/portal/salesChannelProduct/promotionTag/${uuid}`, params || {});
};

const postPromotionTag = (body, params) => {
  return post(`/portal/salesChannelProduct/promotionTag`, body, params || {});
};

export {
  getPromotionTags,
  postPromotionTagsSort,
  deletePromotionTags,
  getPromotionTag,
  postPromotionTag,
};
